const backendEn = {
  auth_not_authenticated: 'Please sign in to continue.',
  auth_permission_denied_add_org: "You don't have permission to add an organisation.",
  payload_missing_required_fields: 'Some required information is missing.',
  organisation_invalid_type: 'The organisation type is not valid.',
  organisation_duplicate_owner_name: 'An organisation with this name already exists.',
  organisation_create_failed: "We couldn't create the organisation.",
  organisation_set_claims_failed_owner: "We couldn't update the owner's permissions.",
  organisation_set_claims_failed_user: "We couldn't update the user permissions.",
  organisation_add_failed: "We couldn't add the organisation.",
  organisation_not_found: "We couldn't find that organisation.",
  organisation_missing_fields: 'The organisation record is missing required information.',
  onboarding_not_new_user: 'This account has already completed onboarding.',
  onboarding_unknown_error: 'Something went wrong while finishing onboarding.',
  email_invalid_argument: 'Enter a valid email address.',
  email_already_verified: 'This email is already verified.',
  email_no_data: "We couldn't prepare the verification email.",
  email_sending_failed: "We couldn't send the email. Try again later.",
  email_verification_failed: "We couldn't send a new verification email.",
  promoter_not_found: "We couldn't find that promoter.",
  promoter_missing_claims: 'The promoter profile is incomplete.',
  password_strength_failed: 'Choose a stronger password that meets all requirements.',
  invitation_invalid_token: 'Your invitation link is invalid or has expired. Please open the most recent invite email.',
  invitation_not_found: "We couldn't find that invitation.",
  invitation_not_pending: 'This invitation is no longer pending.',
  invitation_missing_id: 'The invitation reference is missing.',
  invitation_public_cancel_denied: "Public invitations can't be cancelled.",
  invitation_not_inviter: 'Only the inviter can manage this invitation.',
  invitation_not_inviter_or_delegate: 'Only the inviter or their delegate can manage this invitation.',
  invitation_promoter_not_public: "This promoter doesn't accept public invitations.",
  invitation_invalid_email_format: 'Enter a valid email and password.',
  invitation_invalid_role_division: 'The selected role or division is not allowed.',
  invitation_already_accepted: 'This person already accepted an invitation.',
  invitation_email_in_use: 'This email is already registered.',
  invitation_create_failed: "We couldn't create the invitation.",
  invitation_create_user_failed: "We couldn't create the user account.",
  invitation_create_user_ref_failed: "We couldn't link the user account.",
  invitation_inviter_data_failed: "We couldn't load the inviter's details.",
  invitation_inviter_claims_failed: "We couldn't load the inviter's permissions.",
  invitation_custom_claims_too_large: 'The invitation permissions are too large.',
  invitation_invite_permission_denied: "You don't have permission to invite someone.",
  invitation_fetch_failed: "We couldn't load the invitations.",
  invitation_user_missing_email: 'Your account needs an email address.',
  invitation_owner_missing: "We couldn't find the promoter owner.",
  invitation_role_not_authorized: "This role isn't authorised for invitations.",
  invitation_role_not_found: "We couldn't find that role.",
  invitation_pending_exists: 'An invitation is already in progress for this person.',
  invitation_cancel_unknown: "We couldn't cancel the invitation.",
  invitation_reject_unknown: "We couldn't reject the invitation.",
  invitation_request_unknown: "We couldn't submit the invitation request.",
  verify_email_unknown: "We couldn't verify the email.",
  superuser_unauthorized: 'Only superusers can perform this action.',
  superuser_invitations_unknown: "We couldn't load the invitation list.",
  superuser_users_unknown: "We couldn't load the user list.",
  superuser_organisations_unknown: "We couldn't load the organisation list.",
  signup_requires_auth: 'Please sign in to continue.',
  signup_unknown_error: 'Something went wrong while creating the account.',
  signup_update_password_failed: "We couldn't update the password.",
  provider_already_exists: 'This provider already exists.',
  custom_claims_set_failed: "We couldn't update the account permissions.",
} as const;

export default backendEn;
